import React, { useState, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeHighlighter } from '../../util/ChangeHighlighter';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import ChangeHighlightedImmutableUnderReviewControl from '../../util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export const EmployeeActivityApportionmentFragment = _ref => {
  let {
    type,
    claim,
    apportionment,
    handleApportionmentChange,
    claimEmployeeRndApportionmentsService,
    isShowInvolvement
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const handleChange = useCallback(event => {
    const newApportionment = {
      ...apportionment
    };
    newApportionment[event.target.name] = event.target.value;
    handleApportionmentChange(newApportionment);
  }, [handleApportionmentChange, apportionment]);
  const saveChange = useCallback(event => {
    let method;
    if (apportionment.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeeRndApportionmentsService[method](claim.id, apportionment).then(updatedApportionment => {
      setHasError(false);
      handleApportionmentChange(updatedApportionment);
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [claim, handleApportionmentChange, apportionment, dispatch]);
  const rndDirectIndirectSection = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex ms-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
      as: Form.Control,
      onChange: handleChange,
      onBlur: saveChange,
      object: {
        ...apportionment,
        claim
      },
      disabled: claim.financials_locked || user.account_type === 'customer',
      name: "direct_rnd_apportionment",
      type: "text",
      size: "sm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
      as: Form.Control,
      onChange: handleChange,
      onBlur: saveChange,
      object: {
        ...apportionment,
        claim
      },
      disabled: claim.financials_locked || user.account_type === 'customer',
      name: "direct_duration_in_months",
      type: "text",
      size: "sm"
    })), type === 'UkSection::ClaimEmployee' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
      as: Form.Control,
      onChange: handleChange,
      onBlur: saveChange,
      object: {
        ...apportionment,
        claim
      },
      disabled: claim.financials_locked || user.account_type === 'customer',
      name: "indirect_rnd_apportionment",
      type: "text",
      size: "sm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
      as: Form.Control,
      onChange: handleChange,
      onBlur: saveChange,
      object: {
        ...apportionment,
        claim
      },
      disabled: claim.financials_locked || user.account_type === 'customer',
      name: "indirect_duration_in_months",
      type: "text",
      size: "sm"
    }))));
  };
  const involementSection = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex ms-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: Form.Control,
      onChange: handleChange,
      onBlur: saveChange,
      object: {
        ...apportionment,
        claim
      },
      disabled: claim.financials_locked || user.account_type === 'customer',
      name: "involvement",
      type: "text",
      size: "sm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: Form.Control,
      onChange: handleChange,
      onBlur: saveChange,
      object: {
        ...apportionment,
        claim
      },
      disabled: claim.financials_locked || user.account_type === 'customer',
      name: "quality_expenditures",
      type: "text",
      size: "sm"
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${hasError ? 'bg-warning' : ''} cost_categories_subpage_row_cell_container`
  }, isShowInvolvement ? involementSection() : rndDirectIndirectSection());
};